<template>
    <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import chartResize from './mixins/chart-resize';
export default {
    mixins: [chartResize],
    props: {
        className: {
            type: String,
            default: 'echarts'
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: true
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                //    if(Object.keys(val).length === 0) return
                this.$nextTick(() => {
                    this.setOptions(val);
                });
            }
        }
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        initChart() {
            this.chart = this.$echarts.init(this.$el, 'macarons');
            this.setOptions(this.chartData);
        },
        setOptions(query = {}) {
            if (Object.keys(query).length === 0) {
                this.chart._dom.innerHTML = '-暂无相关数据-';
                this.chart._dom.style.cssText = 'text-align:center; color:#999; border: none;line-height: 300px';
                this.chart._dom.removeAttribute('_echarts_instance_');
                return;
            }
            const {
                xAxis,
                yAxis = { type: 'value', minInterval: 1 },
                series,
                tooltip,
                rest: { isShow = true }
            } = query;
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                // echart 内置下载刷新 切换类型
                toolbox: {
                    show: true,
                    right: '2%',
                    top: '0',
                    feature: {
                        dataView: { show: true, readOnly: false, title: $t('integration.text') },
                        magicType: {
                            show: true,
                            type: ['line', 'bar'],
                            title: {
                                line: $t('integration.switch_to_line_chart'),
                                bar: $t('integration.switch_to_histogram')
                            }
                        },
                        restore: { show: true, title: $t('public.reflash') },
                        saveAsImage: { show: true, title: $t('integration.picture_download') }
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxis || [],
                        axisLabel: {
                            interval: 0, //横轴信息全部显示
                            rotate: 60 //60度角倾斜显示
                            // formatter: function (val) {
                            //     return val.split("").join("\n");
                            // } //横轴信息文字竖直显示
                        }
                    }
                ],

                yAxis,
                legend: {
                    isShow: isShow,
                    top: '2%',
                    left: 0,
                    right: '15%',
                    itemHeight: 10,
                    itemWidth: 10,
                    textStyle: {
                        //图例文字的样式
                        fontSize: 12
                    }
                },
                grid: {
                    top: 70
                },
                series
            };

            // 可以自定义tooltip  用于数据的格式化
            if (tooltip) {
                option.tooltip = { ...option.tooltip, ...tooltip };
            }
            this.chart.setOption(option);
        }
    }
};
</script>

<style></style>
